/* layal-produit.js : page Layal sous le hero (galerie, bloc d'achat, vidéos, livraison, onglets, conseils du blog,
 * FAQ, WhatsApp).
 *
 * Portage Shopify de preview/assets/produit-layal.js : le balisage est rendu par les sections Liquid
 * (sections/layal-*.liquid) ; ce fichier n'ajoute que le comportement. Données du bloc d'achat : JSON
 * <script type="application/json" data-lp-donnees> de sections/layal-produit.liquid (couleurs, variantes avec prix,
 * prix barré, disponibilité et stock réel, lots, livraison). Aucune donnée produit ici.
 *
 * Synchronisation avec le hero (assets/layal-hero-couleurs.js, API racine.heroCouleurs), comme la maquette :
 * - choix de la visiteuse dans le hero (événement « hc:coloris ») -> couleur de l'article 1 du bloc d'achat, prix et
 *   stock de sa variante, images de la couleur dans toute la page (attribut data-lp-img-coloris) ;
 * - choix dans le bloc d'achat -> heroCouleurs.choisirColoris(id) (le hero met aussi l'adresse à jour : ?variant=) ;
 *   sans hero, l'adresse est mise à jour ici ;
 * - le défilement automatique du hero n'émet aucun événement : il ne touche jamais au bloc d'achat.
 * Panier : vrai ajout (Layal.ajouterAuPanier, assets/layal-commun.js), Solo par variante, Duo/Trio par produit
 * tarifé avec ses propriétés de coloris, puis tiroir panier. Le prix est appliqué par Shopify.
 * Lots : l'offre cochée au chargement vient du serveur (réglage « Offre présélectionnée ») ; repli sur Solo si elle
 * reste inactive ici. Adresse avec ?offre=1, 2 ou 3 (liens du guide) : cette offre à la place, si elle est active.
 * Ouverture avec une ancre (#choisir-mon-lot) : placement immédiat sur la cible, sans glissement depuis le haut.
 * Prix par maintien des lots recalculé avec leur prix (prixParMaintien).
 * Autres produits (ex. voile aimanté), seulement si les données le prévoient (sinon comportement inchangé) :
 * - kit : article d'un lot pris dans un autre produit (cfg.autre, lots[].autre = rang de l'article) ; son coloris suit
 *   celui de l'article 1 (correspondance, ex. Nude -> Beige) tant que la visiteuse ne le change pas ; noms des
 *   articles du lot (lots[].articles) affichés et envoyés en propriétés du panier ;
 * - complément (cfg.complement) : case jamais cochée d'avance ; cochée, son coloris s'ajoute dans le même envoi ;
 * - formules extensibles (lots[].extensions, ex. 3 voiles -> 4 -> 5) : « + Ajouter » sous la dernière rangée et « × »
 *   sur les rangées ajoutées ; la carte, le bouton, la barre et la 1re image de la galerie suivent la formule ;
 *   lots[].image : visuel « boîte » de la carte et de la galerie quand ce lot est choisi ;
 * - barre d'achat collante (cfg.barre) : visible quand le haut de page (bouton du hero compris), les offres et le
 *   bouton sont hors de l'écran ; racine.lpAjouter() : ajout du bouton principal, appelé par le hero (JSON « lot »).
 * Éditeur de thème : chaque section se réinitialise quand elle est rechargée (shopify:section:load).
 */
(function () {
  "use strict";

  var SVG_NS = "http://www.w3.org/2000/svg";
  var JOUR = 86400000;
  var RANGS = 3; // nombre maximal d'articles avec un choix de couleur (Trio)

  // ---------- Outils ----------
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function icone(nom, classe) {
    var s = document.createElementNS(SVG_NS, "svg");
    s.setAttribute("class", "lp-icone" + (classe ? " " + classe : ""));
    s.setAttribute("aria-hidden", "true");
    s.setAttribute("focusable", "false");
    var u = document.createElementNS(SVG_NS, "use");
    u.setAttribute("href", "#i-" + nom);
    s.appendChild(u);
    return s;
  }
  function animationsReduites() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  function lireJson(el) {
    if (window.Layal && window.Layal.lireJson) return window.Layal.lireJson(el);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function listeFr(noms) {
    if (noms.length < 2) return noms.join("");
    return noms.slice(0, -1).join(", ") + " et " + noms[noms.length - 1];
  }
  function hero() { return $("[data-hero-couleurs]"); }
  function apiHero() { var h = hero(); return h && h.heroCouleurs ? h.heroCouleurs : null; }
  function stockReelBas(variante, reglage) {
    return Boolean(variante && reglage && variante.disponible && typeof variante.stock === "number" &&
      variante.stock > 0 && variante.stock <= reglage.seuil);
  }
  // Prix par maintien d'un lot (centimes) : arrondi au centime le plus proche, comme le rendu Liquid
  // (snippets/layal-produit-lots.liquid). 0 pour une seule unité ou un prix inconnu.
  function prixParMaintien(centimes, quantite) {
    var q = Number(quantite) || 1;
    var p = Number(centimes) || 0;
    return q > 1 && p > 0 ? Math.round(p / q) : 0;
  }
  // Offre cochée par le serveur (réglage « Offre présélectionnée ») mais désactivée ici : le lot d'une unité
  // (Solo), s'il existe et reste actif. Renvoie l'id du lot à cocher, ou null s'il n'y a rien à changer.
  function lotDeRepli(lotsListe, radios) {
    var coche = radios.filter(function (input) { return input.checked; })[0];
    if (!coche || !coche.disabled) return null;
    var solo = lotsListe.filter(function (lot) { return lot.quantite === 1; })[0];
    var radioSolo = solo && radios.filter(function (input) { return input.value === solo.id; })[0];
    return radioSolo && !radioSolo.disabled ? solo.id : null;
  }
  // Offre demandée par l'adresse (?offre=1, 2 ou 3 : quantité du lot ; liens des offres du guide). Renvoie l'id du
  // lot à cocher s'il existe et reste actif ici (produit lot disponible, script prêt), sinon null : rien ne change.
  function lotDeAdresse(lotsListe, radios, recherche) {
    var valeur = null;
    try { valeur = new URLSearchParams(recherche || "").get("offre"); } catch (e) { return null; }
    if (!/^[1-9]$/.test(valeur || "")) return null;
    var quantite = Number(valeur);
    var lot = lotsListe.filter(function (candidat) { return (candidat.quantiteOffre || candidat.quantite) === quantite; })[0];
    var radio = lot && radios.filter(function (input) { return input.value === lot.id; })[0];
    return radio && !radio.disabled ? lot.id : null;
  }

  // ---------- Images de la couleur choisie, dans toute la page ----------
  // Couleurs connues (id -> { nom, image }) : JSON des blocs d'achat, puis celui du hero (prioritaire : un bloc
  // « Couleur » du hero peut porter sa propre image détourée).
  var colorisPage = {};
  function enregistrerColoris(liste) {
    (liste || []).forEach(function (c) {
      if (!c || !c.id) return;
      var actuel = colorisPage[c.id] || {};
      colorisPage[c.id] = { nom: c.nom || actuel.nom, image: c.image || actuel.image };
    });
  }
  function colorisDuHero() {
    var api = apiHero();
    if (api && api.colorisListe) enregistrerColoris(api.colorisListe());
  }
  function majImagesColoris(id) {
    var c = colorisPage[id];
    if (!c) return;
    $$("[data-lp-img-coloris]").forEach(function (img) {
      if (c.image && img.getAttribute("src") !== c.image) img.src = c.image;
      var modele = img.getAttribute("data-lp-alt");
      if (modele) img.alt = modele.replace("[nom]", c.nom);
    });
  }

  // ---------- a. Code promo : copie (la cliente le saisit au paiement) ----------
  function copierRepli(texte) {
    var t = document.createElement("textarea");
    t.setAttribute("readonly", "");
    t.setAttribute("aria-hidden", "true");
    t.tabIndex = -1;
    t.style.cssText = "position:fixed;top:0;left:-9999px;opacity:0";
    t.value = texte;
    document.body.appendChild(t);
    t.select();
    var ok = false;
    try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
    document.body.removeChild(t);
    return ok;
  }
  function copier(texte) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(texte).then(function () { return true; }, function () { return copierRepli(texte); });
    }
    return Promise.resolve(copierRepli(texte));
  }
  function initPromo(racine) {
    var bouton = $("[data-lp-copier]", racine);
    if (!bouton) return;
    var code = bouton.getAttribute("data-lp-copier");
    var libelle = $("span", bouton);
    var codeEl = $("[data-lp-promo-code]", racine);
    var statut = $("[data-lp-promo-statut]", racine);
    var minuterie = null;
    function remettre() {
      bouton.classList.remove("est-copie");
      bouton.replaceChild(icone("copier"), bouton.firstElementChild);
      libelle.textContent = "Copier le code";
    }
    bouton.addEventListener("click", function () {
      copier(code).then(function (ok) {
        clearTimeout(minuterie);
        if (ok) {
          bouton.classList.add("est-copie");
          bouton.replaceChild(icone("coche"), bouton.firstElementChild);
          libelle.textContent = "Copié";
          if (statut) statut.textContent = "Code " + code + " copié.";
          minuterie = setTimeout(remettre, 2200);
        } else if (codeEl) {
          // Copie refusée par le navigateur : on sélectionne le code pour une copie manuelle.
          var plage = document.createRange();
          plage.selectNodeContents(codeEl);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(plage);
          if (statut) statut.textContent = "Copie impossible. Le code " + code + " est sélectionné : copiez-le à la main.";
        }
      });
    });
  }

  // ---------- i. Carrousel d'avis ----------
  function initAvis(racine) {
    var piste = $("[data-lp-avis-piste]", racine);
    if (!piste) return;
    var n = piste.children.length;
    function aller(pas) {
      var courant = Math.round(piste.scrollLeft / Math.max(1, piste.clientWidth));
      var cible = (((courant + pas) % n) + n) % n;
      piste.scrollTo({ left: cible * piste.clientWidth, behavior: animationsReduites() ? "auto" : "smooth" });
    }
    $$("[data-lp-avis-pas]", racine).forEach(function (b) {
      b.addEventListener("click", function () { aller(parseInt(b.getAttribute("data-lp-avis-pas"), 10)); });
    });
  }

  // ---------- Galerie ----------
  function initGalerie(racine) {
    var galerie = $("[data-lp-galerie]", racine);
    if (!galerie) return { afficher: function () {} };
    var diapos = $$("[data-lp-diapo]", galerie);
    var vignettes = $$("[data-lp-vignette]", galerie);
    var vue = 0;
    function afficher(i) {
      var n = diapos.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      diapos.forEach(function (d, k) { d.hidden = k !== i; d.classList.toggle("est-active", k === i); });
      vignettes.forEach(function (v, k) { v.setAttribute("aria-pressed", k === i ? "true" : "false"); });
      vue = i;
    }
    vignettes.forEach(function (v, k) { v.addEventListener("click", function () { afficher(k); }); });
    $$("[data-lp-galerie-pas]", galerie).forEach(function (b) {
      b.addEventListener("click", function () { afficher(vue + parseInt(b.getAttribute("data-lp-galerie-pas"), 10)); });
    });
    // Glissé horizontal sur l'image principale (doigt ou stylet) : image suivante ou précédente.
    var vueEl = $(".lp-galerie__vue", galerie);
    var geste = null;
    vueEl.addEventListener("pointerdown", function (e) {
      geste = e.pointerType === "mouse" ? null : { x: e.clientX, y: e.clientY, id: e.pointerId };
    });
    vueEl.addEventListener("pointerup", function (e) {
      if (!geste || e.pointerId !== geste.id) return;
      var dx = e.clientX - geste.x, dy = e.clientY - geste.y;
      geste = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) afficher(vue + (dx < 0 ? 1 : -1));
    });
    vueEl.addEventListener("pointercancel", function () { geste = null; });
    // Éditeur : une photo sélectionnée s'affiche.
    racine.addEventListener("shopify:block:select", function (e) {
      var k = diapos.indexOf(e.target);
      if (k >= 0) afficher(k);
    });
    return { afficher: afficher };
  }

  // ---------- p. Livraison : compte à rebours vers une heure limite FIXE et dates en jours ouvrés ----------
  // Le même pour toutes les visiteuses : jamais de minuteur propre à la visite, jamais de remise à zéro.
  function calculerLivraison(maintenant, L) {
    var fuseau = L.fuseau || "Europe/Paris";
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat("en-GB", {
        timeZone: fuseau, hourCycle: "h23", year: "numeric", month: "numeric", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric"
      });
    } catch (e) {
      fmt = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Paris", hourCycle: "h23", year: "numeric", month: "numeric", day: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric"
      });
    }
    function parties(date) {
      var p = {};
      fmt.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
      return { a: +p.year, m: +p.month, j: +p.day, h: (+p.hour) % 24, mi: +p.minute, s: +p.second };
    }
    // Instant (ms) correspondant à une heure locale du fuseau (décalage lu à cette date : heure d'été comprise).
    function instant(a, m, j, hh, mm) {
      var essai = Date.UTC(a, m - 1, j, hh, mm);
      var p = parties(new Date(essai));
      return essai - (Date.UTC(p.a, p.m - 1, p.j, p.h, p.mi) - essai);
    }
    var feries = {};
    (L.joursFeries || []).forEach(function (d) { feries[d] = true; });
    function iso(t) { return new Date(t).toISOString().slice(0, 10); }
    function ouvre(t) { var js = new Date(t).getUTCDay(); return js !== 0 && js !== 6 && !feries[iso(t)]; }
    function plusOuvres(t, n) { var x = t, k = 0; while (k < n) { x += JOUR; if (ouvre(x)) k++; } return x; }

    var hl = String(L.heureLimite || "14:00").split(":");
    var limH = +hl[0] || 0, limM = +hl[1] || 0;
    var p = parties(maintenant);
    var jour = Date.UTC(p.a, p.m - 1, p.j); // jour civil dans le fuseau, à minuit UTC (calcul de dates sans fuseau)
    var avantLimite = (p.h * 60 + p.mi) < (limH * 60 + limM);
    var j0 = jour; // jour de préparation : aujourd'hui avant l'heure limite (jour ouvré), sinon le jour ouvré suivant
    if (!ouvre(j0) || !avantLimite) { do { j0 += JOUR; } while (!ouvre(j0)); }
    var d0 = new Date(j0);
    var cible = instant(d0.getUTCFullYear(), d0.getUTCMonth() + 1, d0.getUTCDate(), limH, limM);
    var e = L.expeditionJours || [2, 4], l = L.livraisonJours || [8, 15];
    return {
      minutes: Math.max(1, Math.ceil((cible - maintenant.getTime()) / 60000)), // arrondi supérieur : jamais « 00 h 00 min »
      expedition: [plusOuvres(j0, e[0]), plusOuvres(j0, e[1])],
      livraison: [plusOuvres(j0, l[0]), plusOuvres(j0, l[1])]
    };
  }
  function duree(minutes) {
    function deux(n) { return (n < 10 ? "0" : "") + n; }
    var heures = Math.floor(minutes / 60), mn = minutes % 60;
    if (heures >= 48) return Math.floor(heures / 24) + " j " + deux(heures % 24) + " h " + deux(mn) + " min"; // fin de semaine
    return deux(heures) + " h " + deux(mn) + " min";
  }
  var fmtJour = new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", timeZone: "UTC" });
  function plage(t) {
    var a = new Date(t[0]), b = new Date(t[1]);
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear()) return a.getUTCDate() + " – " + fmtJour.format(b);
    return fmtJour.format(a) + " – " + fmtJour.format(b);
  }
  function initLivraison(racine, L) {
    var zone = $("[data-lp-livraison]", racine);
    if (!zone || !L) return null;
    var temps = $("[data-lp-temps]", zone);
    var exp = $("[data-lp-date-expedition]", zone);
    var liv = $("[data-lp-date-livraison]", zone);
    function maj() {
      var res = calculerLivraison(new Date(), L);
      if (temps) temps.textContent = duree(res.minutes);
      if (exp) exp.textContent = plage(res.expedition);
      if (liv) liv.textContent = plage(res.livraison);
    }
    maj();
    var minuterie = setInterval(maj, 15000);
    var visibilite = function () { if (!document.hidden) maj(); };
    document.addEventListener("visibilitychange", visibilite);
    return function arreter() {
      clearInterval(minuterie);
      document.removeEventListener("visibilitychange", visibilite);
    };
  }

  // ---------- Bloc d'achat ----------
  function initProduit(racine) {
    if (racine.dataset.lpPret) return;
    var cfg = lireJson($("[data-lp-donnees]", racine));
    if (!cfg) return;
    racine.dataset.lpPret = "1";

    var coloris = cfg.coloris || [];
    var colorisParId = {};
    coloris.forEach(function (c) { colorisParId[c.id] = c; });
    enregistrerColoris(coloris);
    var variantes = cfg.variantes || {};
    var lots = cfg.lots || [];
    var textes = cfg.textes || {};
    var format = cfg.formatMonnaie;
    function prix(centimes) { return window.Layal.formatMonnaie(centimes, format); }
    // Kit : coloris de l'autre produit, jamais mélangés à ceux de la page (ex. « noir » du voile et du maintien).
    var autre = cfg.autre || null;
    var colorisAutreParId = {};
    if (autre) (autre.coloris || []).forEach(function (c) { colorisAutreParId[c.id] = c; });
    function rangAutre(lot) { return lot && typeof lot.autre === "number" ? lot.autre : -1; }
    function estAutre(lot, rang) { var debut = rangAutre(lot); return debut >= 0 && rang >= debut && rang < debut + (lot.autreNombre || 1); }
    function couleurAutre(rang) { return etat.autres[rang] || etat.autre; }
    // Complément : coloris proposés (prix affiché, prix de référence, image, variante).
    var complement = cfg.complement || null;
    var complementParId = {};
    if (complement) (complement.coloris || []).forEach(function (c) { complementParId[c.id] = c; });

    var RANGS_SECTION = RANGS;
    lots.forEach(function (lot) {
      var max = (lot.quantite || 1) + (lot.extensions ? lot.extensions.length : 0);
      if (max > RANGS_SECTION) RANGS_SECTION = Math.min(max, 5);
    });
    var radioLot = $("[data-lp-lot]:checked", racine);
    var etat = {
      lot: radioLot ? radioLot.value : (lots[0] && lots[0].id),
      couleurs: [],
      touche: [], // articles 2 et suivants : couleur choisie par la visiteuse (sinon ils suivent l'article 1)
      extension: 0 // formules extensibles : articles ajoutés au lot choisi (0, 1 ou 2)
    };
    var radioCouleur = $("[data-lp-rang='0']:checked", racine);
    var depart = radioCouleur ? radioCouleur.value : (coloris[0] && coloris[0].id);
    for (var r = 0; r < RANGS_SECTION; r++) { etat.couleurs[r] = depart; etat.touche[r] = false; }
    var radioAutre = $("[data-lp-rang-autre]:checked", racine);
    etat.autre = radioAutre ? radioAutre.value : null;
    etat.autreTouche = false;
    etat.autres = {};
    etat.autresTouches = {};
    var caseComplement = $("[data-lp-complement-case]", racine);
    var radioComplement = $("[data-lp-complement-choix]:checked", racine);
    etat.complement = { coche: false, id: radioComplement ? radioComplement.value : null };

    function lotDeBase() {
      for (var i = 0; i < lots.length; i++) if (lots[i].id === etat.lot) return lots[i];
      return lots[0] || { id: null, nom: "", quantite: 1, prix: null };
    }
    // Lot choisi ; formule extensible : la formule à 4 ou 5 articles (même carte, son produit lot et son prix).
    function lotCourant() {
      var base = lotDeBase();
      var ext = base.extensions && etat.extension > 0 ? base.extensions[etat.extension - 1] : null;
      if (!ext) return base;
      var derive = {};
      Object.keys(base).forEach(function (cle) { derive[cle] = base[cle]; });
      derive.quantite = ext.quantite;
      derive.nom = ext.nom || base.nom;
      derive.prix = ext.prix || null;
      derive.varianteLot = ext.varianteLot;
      derive.disponible = ext.disponible === true;
      derive.image = ext.image || base.image;
      derive.vignette = ext.vignette || base.vignette;
      var debut = String(base.quantite || "");
      derive.sousTitre = base.sousTitre && base.sousTitre.indexOf(debut + " ") === 0 ? ext.quantite + base.sousTitre.slice(debut.length) : "";
      if (!derive.disponible) derive.sousTitre = "Indisponible";
      return derive;
    }
    function varianteDe(id) {
      var c = colorisParId[id];
      return c && c.variante ? variantes[String(c.variante)] : null;
    }

    initPromo(racine);
    initAvis(racine);
    var galerie = initGalerie(racine);
    racine._lpArreter = initLivraison(racine, cfg.livraison);

    // Prix d'un lot pour la variante de l'article 1 : prix affiché du lot, sinon prix x quantité. Kit : l'article de
    // l'autre produit compte à son propre prix dans le prix barré (articles achetés seuls).
    function prixArticleAutre(lot) {
      var c = colorisAutreParId[etat.autre];
      return c && typeof c.prix === "number" ? c.prix : (Number(lot.prixAutre) || 0);
    }
    function calculLot(lot, v) {
      var q = lot.quantite || 1;
      var regulier = v ? v.prix * q : 0;
      if (v && typeof lot.autre === "number") regulier = v.prix * (q - (lot.autreNombre || 1)) + prixArticleAutre(lot) * (lot.autreNombre || 1);
      var paye = lot.prix ? lot.prix : regulier;
      var barre = 0;
      if (q === 1 && v && v.prixBarre) barre = v.prixBarre;
      else if (paye < regulier) barre = regulier;
      var eco = lot.sousTitre || "";
      if (!eco && paye < regulier && regulier > 0) {
        var pct = Math.round((regulier - paye) * 100 / regulier);
        if (pct >= 1) eco = (textes.economisez || "Économisez") + " " + pct + " %";
      }
      return { paye: paye, barre: barre > paye ? barre : 0, eco: eco };
    }

    // ---------- f, j, k, m. Prix, lots, stock, bouton (variante de l'article 1) ----------
    var boutonAjouter = $("[data-lp-ajouter]", racine);
    var boutonTexte = $("[data-lp-ajouter-texte]", racine);
    var boutonSeparateur = $("[data-lp-ajouter-separateur]", racine);
    var boutonPrix = $("[data-lp-ajouter-prix]", racine);
    var statutPanier = $("[data-lp-statut-panier]", racine);
    var statutPrix = $("[data-lp-statut-prix]", racine);
    var erreur = $("[data-lp-erreur]", racine);
    var champVariante = $("[data-lp-variante]", racine);

    function majPrix() {
      var v = varianteDe(etat.couleurs[0]);
      if (!v) return;
      var reference = $("[data-lp-prix-reference]", racine);
      var montantBarre = $("[data-lp-prix-barre]", racine);
      var libelleActuel = $("[data-lp-prix-actuel-libelle]", racine);
      var badge = $("[data-lp-prix-badge]", racine);
      var actuel = $("[data-lp-prix-actuel]", racine);
      var prixFormule = $("[data-lp-prix-formule]", racine);
      var nomFormule = $("[data-lp-prix-formule-nom]", racine);
      var formule = lotCourant();
      var prixBarre = !prixFormule || formule.quantite === 1 ? v.prixBarre : 0;
      if (actuel) actuel.textContent = prix(prixFormule ? calculLot(formule, v).paye : v.prix);
      if (nomFormule) nomFormule.textContent = formule.nom + " · avant code";
      if (reference) reference.hidden = !prixBarre;
      if (montantBarre) montantBarre.textContent = prixBarre ? prix(prixBarre) : "";
      if (libelleActuel) libelleActuel.hidden = !prixBarre;
      if (badge) badge.hidden = !prixBarre;

      // Cartes des lots.
      $$(".lp-lot", racine).forEach(function (carte) {
        var radio = $("[data-lp-lot]", carte);
        var lot = null;
        for (var i = 0; i < lots.length; i++) if (radio && lots[i].id === radio.value) lot = lots[i];
        if (!lot) return;
        if (lot.extensions && lot.id === etat.lot) {
          lot = lotCourant();
          var nomEl = $(".lp-lot__nom", carte);
          if (nomEl && nomEl.textContent !== lot.nom) nomEl.textContent = lot.nom;
        } else if (lot.extensions) {
          var nomBase = $(".lp-lot__nom", carte);
          if (nomBase && nomBase.textContent !== lot.nom) nomBase.textContent = lot.nom;
        }
        var boite = $("[data-lp-lot-boite]", carte);
        var imageCarte = lot.id === etat.lot ? lotCourant().vignette : lot.vignette;
        if (boite && imageCarte && boite.getAttribute("src") !== imageCarte) boite.src = imageCarte;
        // Les lots restent désactivés tant que leurs données ET leur ajout avec coloris ne sont pas prêts.
        if (radio) radio.disabled = lot.quantite > 1 && (!lot.varianteLot || lot.disponible !== true || typeof window.Layal.lignesPourLot !== "function");
        var calc = calculLot(lot, v);
        var prixEl = $("[data-lp-lot-prix]", carte);
        var barreEl = $("[data-lp-lot-barre]", carte);
        var barreMontant = $("[data-lp-lot-barre-montant]", carte);
        var ecoEl = $("[data-lp-lot-eco]", carte);
        var unitaireEl = $("[data-lp-lot-unitaire]", carte);
        if (prixEl) prixEl.textContent = prix(calc.paye);
        if (barreEl) barreEl.hidden = !calc.barre;
        if (barreMontant) barreMontant.textContent = calc.barre ? prix(calc.barre) : "";
        if (ecoEl && calc.eco && !racine.hasAttribute("data-lp-maintien") && !racine.hasAttribute("data-lp-voile")) ecoEl.textContent = calc.eco;
        if (unitaireEl) {
          var parMaintien = typeof lot.autre === "number" ? 0 : prixParMaintien(calc.paye, lot.quantite);
          // Texte identique au rendu serveur (cas courant) : on garde son balisage (montant d'un seul tenant).
          var texteUnitaire = parMaintien && textes.prixUnitaire ? String(textes.prixUnitaire).replace("[prix]", prix(parMaintien)) : "";
          if (texteUnitaire && unitaireEl.textContent !== texteUnitaire) unitaireEl.textContent = texteUnitaire;
          unitaireEl.hidden = !parMaintien || !textes.prixUnitaire;
        }
      });

      // Une ancienne option « permanent » ne peut pas créer d'urgence sans stock réel suivi.
      var zoneStock = $("[data-lp-stock]", racine);
      var texteStock = $("[data-lp-stock-texte]", racine);
      if (zoneStock && cfg.stock) {
        var s = cfg.stock;
        var visible = stockReelBas(v, s);
        zoneStock.hidden = !visible;
        if (visible && texteStock) {
          texteStock.textContent = String(s.texte || "Plus que [quantite] en stock").replace("[quantite]", typeof v.stock === "number" ? v.stock : "");
        }
      }
      majBouton();
    }

    function selectionDisponible() {
      var lot = lotCourant();
      var q = Math.min(lot.quantite || 1, RANGS_SECTION);
      if (q > 1 && (!lot.varianteLot || lot.disponible !== true)) return false;
      for (var k = 0; k < q; k++) {
        if (estAutre(lot, k)) {
          var ca = colorisAutreParId[couleurAutre(k)];
          if (!ca || !ca.variante || ca.disponible !== true) return false;
          continue;
        }
        var v = varianteDe(etat.couleurs[k]);
        if (!v || !v.disponible) return false;
      }
      return true;
    }
    // Complément coché et disponible : sa ligne de panier et son prix affiché ; sinon rien.
    function complementChoisi() {
      if (!complement || !etat.complement.coche) return null;
      var c = complementParId[etat.complement.id];
      return c && c.variante && c.disponible ? c : null;
    }
    function totalChoisi(v) {
      var c = complementChoisi();
      return calculLot(lotCourant(), v).paye + (c ? Number(c.prix) || 0 : 0);
    }
    function majBouton() {
      if (!boutonAjouter) return;
      var v = varianteDe(etat.couleurs[0]);
      var dispo = selectionDisponible();
      boutonAjouter.disabled = !dispo;
      if (boutonTexte) boutonTexte.textContent = dispo ? (textes.ajouter || "") : (textes.epuise || "");
      if (boutonSeparateur) boutonSeparateur.textContent = dispo ? " · " : "";
      if (boutonPrix) boutonPrix.textContent = dispo && v ? prix(totalChoisi(v)) : "";
      if (champVariante) {
        var c = colorisParId[etat.couleurs[0]];
        if (c && c.variante) champVariante.value = c.variante;
      }
      majBarre(dispo, v);
    }

    // ---------- j. Lots ----------
    var imagesLots = $$(".lp-lot", racine).map(function (carte) { return $$("[data-lp-lot-img]", carte); });
    var lotsDesCartes = $$(".lp-lot", racine).map(function (carte) {
      var radio = $("[data-lp-lot]", carte);
      return radio ? lots.filter(function (lot) { return lot.id === radio.value; })[0] || null : null;
    });
    function majVisuelsLots() {
      imagesLots.forEach(function (imgs, i) {
        var rangKit = rangAutre(lotsDesCartes[i]);
        imgs.forEach(function (img, k) {
          var c = estAutre(lotsDesCartes[i], k) ? colorisAutreParId[couleurAutre(k)] : (colorisPage[etat.couleurs[k]] || colorisParId[etat.couleurs[k]]);
          if (c && c.image && img.getAttribute("src") !== c.image) img.src = c.image;
        });
      });
    }
    var zoneSimple = $("[data-lp-couleur-simple]", racine);
    var zoneMulti = $("[data-lp-couleur-multi]", racine);
    var rangees = $$("[data-lp-rangee]", racine);
    var rangeesAutres = $$("[data-lp-rangee-autre]", racine);
    // Noms des rangées (kit, lots nommés) : noms des articles du lot, sinon « Voile 1 », « Voile 2 »…
    function majLibelles(lot) {
      if (typeof cfg.libelleArticle !== "string") return;
      $$("[data-lp-libelle-rang]", racine).forEach(function (el) {
        var k = parseInt(el.getAttribute("data-lp-libelle-rang"), 10) || 0;
        var nom = lot.articles && lot.articles[k] ? lot.articles[k] : cfg.libelleArticle + " " + (k + 1);
        el.textContent = el.tagName === "LEGEND" ? "Couleur : " + nom : nom;
      });
      rangeesAutres.forEach(function (rangee) {
        var rang = Number(rangee.getAttribute("data-lp-rangee-autre"));
        var nom = racine.hasAttribute("data-lp-voile") ? "Maintien " + (rang - rangAutre(lot) + 1) : racine.hasAttribute("data-lp-maintien") ? "Voile " + (rang - rangAutre(lot) + 1) : lot.articles && lot.articles[rang] || "Maintien";
        $$("[data-lp-libelle-autre]", rangee).forEach(function (el) {
          el.textContent = el.tagName === "LEGEND" ? "Couleur : " + nom : nom;
        });
      });
    }

    function majPhotoCadeau(lot) {
      var zone = $("[data-lp-cadeaux]", racine);
      if (!zone || rangAutre(lot) < 0) return;
      var photo = $("[data-lp-cadeaux-image]", zone);
      var source = $("[data-lp-cadeaux-images]", zone);
      var couleur = colorisAutreParId[couleurAutre(rangAutre(lot))];
      if (!photo || !source || !couleur) return;
      var images;
      try { images = JSON.parse(source.textContent); } catch (_) { return; }
      if (images[couleur.id]) {
        if (photo.getAttribute("src") !== images[couleur.id]) photo.src = images[couleur.id];
        photo.alt = (racine.hasAttribute("data-lp-voile") ? "Maintien antiglisse Layal, " : "Voile aimanté Layal, ") + couleur.nom;
      }
    }
    function majAffichageCouleurs() {
      if (!zoneSimple || !zoneMulti) return;
      var lot = lotCourant();
      var q = lot.quantite || 1;
      var rang = rangAutre(lot);
      zoneSimple.hidden = q > 1;
      zoneMulti.hidden = q <= 1;
      rangees.forEach(function (rangee, k) { rangee.hidden = k >= q || estAutre(lot, k); });
      rangeesAutres.forEach(function (rangee) { var k = Number(rangee.getAttribute("data-lp-rangee-autre")); rangee.hidden = k >= q || !estAutre(lot, k); });
      var cadeaux = $("[data-lp-cadeaux]", racine);
      if (cadeaux) {
        cadeaux.hidden = rang < 0;
        var titreCadeau = $("[data-lp-cadeaux-titre]", cadeaux);
        if (titreCadeau) titreCadeau.textContent = racine.hasAttribute("data-lp-voile") ? (lot.autreNombre > 1 ? "Vos " + lot.autreNombre + " maintiens inclus (offerts après code)" : "Votre maintien inclus (offert après code)") : (lot.autreNombre > 1 ? "Vos " + lot.autreNombre + " voiles inclus (offerts après code)" : "Votre voile inclus (offert après code)");
      }
      majPhotoCadeau(lot);
      majLibelles(lot);
      majExtension();
      // Complément (ex. maintien sur la page du voile) : inutile avec une formule qui en contient déjà un (kit).
      var zoneComplement = $("[data-lp-complement]", racine);
      if (zoneComplement) {
        zoneComplement.hidden = rang >= 0;
        if (rang >= 0 && caseComplement && caseComplement.checked) {
          caseComplement.checked = false;
          etat.complement.coche = false;
          var zoneColorisComplement = $("[data-lp-complement-coloris]", racine);
          if (zoneColorisComplement) zoneColorisComplement.hidden = true;
        }
      }
    }
    // ---------- Formules extensibles et visuel « boîte » ----------
    var boutonAjoutRang = $("[data-lp-ajouter-rang]", racine);
    function majExtension() {
      var base = lotDeBase();
      var max = base.extensions ? base.extensions.length : 0;
      if (boutonAjoutRang) boutonAjoutRang.hidden = !max || etat.extension >= max || !base.extensions[etat.extension].varianteLot;
      majImageGalerie();
    }
    // 1re image de la galerie : visuel « boîte » de la formule choisie, sinon l'image d'origine.
    var premiereImage = $("[data-lp-diapo] img", racine);
    var premiereVignette = $("[data-lp-vignette] img", racine);
    var origine = premiereImage ? { src: premiereImage.getAttribute("src"), srcset: premiereImage.getAttribute("srcset"), alt: premiereImage.getAttribute("alt"), vignette: premiereVignette && premiereVignette.getAttribute("src") } : null;
    // Nom du fichier sans dossier, paramètres ni suffixe de taille (« _1000x ») : le visuel de la formule déjà rendu
    // en 1re image par le serveur (ex. coffret du Kit présélectionné) n'est pas téléchargé une 2e fois.
    function fichierDe(url) { return String(url || "").replace(/^.*\//, "").replace(/\?.*$/, "").replace(/_\d*x\d*(\.\w+)$/, "$1"); }
    function majImageGalerie() {
      if (!origine || premiereImage.hasAttribute("data-lp-img-coloris")) return;
      var lot = lotCourant();
      // Image par coloris de l'article 1 (ex. voile porté, kit) sinon image du lot (ex. coffret de 3 voiles).
      var cle = etat.couleurs[0];
      var parColoris = lot.imagesColoris && lot.imagesColoris[cle];
      var voulue = parColoris || lot.image;
      var image = voulue && fichierDe(voulue) !== fichierDe(origine.src) ? voulue : null;
      var src = image || origine.src;
      if (premiereImage.getAttribute("src") === src) return;
      if (image) premiereImage.removeAttribute("srcset");
      else if (origine.srcset) premiereImage.setAttribute("srcset", origine.srcset);
      premiereImage.src = src;
      var c = colorisParId[cle];
      premiereImage.alt = !image ? origine.alt : parColoris ? lot.nom + ", coloris " + (c ? c.nom : cle) : "Coffret Layal : " + lot.nom;
      if (premiereVignette) premiereVignette.src = image ? ((parColoris && lot.vignettesColoris && lot.vignettesColoris[cle]) || lot.vignette || image) : origine.vignette;
    }
    function changerExtension(nouvelle, focus) {
      var base = lotDeBase();
      if (!base.extensions) return;
      etat.extension = Math.max(0, Math.min(nouvelle, base.extensions.length));
      majAffichageCouleurs();
      majVisuelsLots();
      majPrix();
      var lot = lotCourant();
      var v = varianteDe(etat.couleurs[0]);
      if (statutPrix && v) statutPrix.textContent = lot.nom + " : " + prix(calculLot(lot, v).paye) + ".";
      if (lot.image && galerie) galerie.afficher(0);
      if (focus) {
        var cible = focus === "ajout" ? $("[data-lp-rangee='" + (lot.quantite - 1) + "'] input:not([disabled])", racine) : boutonAjoutRang;
        if (cible && !cible.hidden) cible.focus();
      }
    }
    if (boutonAjoutRang) {
      boutonAjoutRang.addEventListener("click", function () { changerExtension(etat.extension + 1, "ajout"); });
    }
    $$("[data-lp-retirer-rang]", racine).forEach(function (bouton) {
      bouton.addEventListener("click", function () {
        var k = parseInt(bouton.getAttribute("data-lp-retirer-rang"), 10);
        var q = lotCourant().quantite || 1;
        // Les rangées suivantes remontent d'un cran (leurs coloris restent ceux choisis).
        for (var j = k; j < q - 1; j++) { etat.couleurs[j] = etat.couleurs[j + 1]; etat.touche[j] = etat.touche[j + 1]; }
        etat.couleurs[q - 1] = etat.couleurs[0];
        etat.touche[q - 1] = false;
        majCouleursUI();
        changerExtension(etat.extension - 1, "retrait");
      });
    });
    function choisirLot(id, parVisiteuse) {
      if (id !== etat.lot) etat.extension = 0;
      etat.lot = id;
      var lot = lotCourant();
      majAffichageCouleurs();
      majVisuelsLots();
      majPrix();
      if (parVisiteuse && statutPrix) {
        var v = varianteDe(etat.couleurs[0]);
        if (v) statutPrix.textContent = lot.nom + " : " + prix(calculLot(lot, v).paye) + ".";
      }
    }
    $$("[data-lp-lot]", racine).forEach(function (input) {
      input.addEventListener("change", function () { if (input.checked) choisirLot(input.value, true); });
    });
    // Accès Solo/Duo/Trio du hero : sélection seulement après un clic explicite, sans changer les coloris.
    racine.lpChoisirQuantite = function (quantite) {
      var lot = lots.filter(function (candidat) { return (candidat.quantiteOffre || candidat.quantite) === quantite; })[0];
      if (!lot) return false;
      var radio = $$("[data-lp-lot]", racine).filter(function (input) { return input.value === lot.id; })[0];
      if (!radio || radio.disabled) return false;
      radio.checked = true;
      etat.extension = 0;
      choisirLot(lot.id, true);
      return true;
    };

    // ---------- l. Couleurs ----------
    // Rang 0 = article 1 (synchronisé avec le hero) ; deux groupes de boutons : les pastilles (une unité) et la
    // première rangée (Duo, Trio). Rangs 1 et 2 : articles 2 et 3.
    var radiosParRang = [];
    var nomsParRang = [];
    for (var rr = 0; rr < RANGS_SECTION; rr++) { radiosParRang.push([]); nomsParRang.push([]); }
    $$("[data-lp-rang]", racine).forEach(function (input) {
      var rang = parseInt(input.getAttribute("data-lp-rang"), 10) || 0;
      if (radiosParRang[rang]) radiosParRang[rang].push(input);
      input.addEventListener("change", function () { if (input.checked) choisirCouleur(rang, input.value, { source: "achat" }); });
    });
    $$("[data-lp-nom-rang]", racine).forEach(function (el) {
      var rang = parseInt(el.getAttribute("data-lp-nom-rang"), 10) || 0;
      if (nomsParRang[rang]) nomsParRang[rang].push(el);
    });
    function majCouleursUI() {
      for (var rang = 0; rang < RANGS_SECTION; rang++) {
        var id = etat.couleurs[rang];
        radiosParRang[rang].forEach(function (input) { input.checked = input.value === id; });
        var c = colorisParId[id];
        nomsParRang[rang].forEach(function (el) { el.textContent = c ? c.nom : ""; });
      }
    }
    // Kit : coloris de l'article de l'autre produit (choix de la visiteuse, ou correspondance avec l'article 1).
    function choisirAutre(id, parVisiteuse, rang) {
      var c = colorisAutreParId[id];
      if (!c) return;
      etat.autre = id;
      if (parVisiteuse) etat.autreTouche = true;
      if (typeof rang === "number") { etat.autres[rang] = id; if (parVisiteuse) etat.autresTouches[rang] = true; }
      majPhotoCadeau(lotCourant());
      $$("[data-lp-rang-autre]", racine).forEach(function (input) { var k = Number(input.getAttribute("data-lp-rang-autre")); input.checked = input.value === couleurAutre(k); });
      rangeesAutres.forEach(function (rangee) { var c = colorisAutreParId[couleurAutre(Number(rangee.getAttribute("data-lp-rangee-autre")))]; if (c) $$("[data-lp-nom-autre]", rangee).forEach(function (el) { el.textContent = c.nom; }); });
      majVisuelsLots();
      majPrix();
    }
    function suivreArticle1(id) {
      if (!autre) return;
      var cible = autre.correspondance && autre.correspondance[id];
      var c = cible && colorisAutreParId[cible];
      if (c && c.disponible) { for (var k = 1; k < RANGS_SECTION; k++) if (!etat.autresTouches[k]) etat.autres[k] = cible; choisirAutre(cible, false); }
    }
    $$("[data-lp-rang-autre]", racine).forEach(function (input) {
      input.addEventListener("change", function () { if (input.checked) choisirAutre(input.value, true, Number(input.getAttribute("data-lp-rang-autre"))); });
    });

    // options.source : "achat" (bloc d'achat -> hero), "hero" (événement du hero), rien (initial).
    function choisirCouleur(rang, id, options) {
      options = options || {};
      var c = colorisParId[id];
      if (!c) return;
      etat.couleurs[rang] = id;
      if (rang > 0) etat.touche[rang] = true;
      else for (var k = 1; k < RANGS_SECTION; k++) if (!etat.touche[k]) etat.couleurs[k] = id;
      if (rang === 0) suivreArticle1(id);
      majCouleursUI();
      majVisuelsLots();
      if (rang === 0) {
        majImagesColoris(id);
        majImageGalerie(); // 1re image par coloris (formule « Voile seul », kit)
        majPrix();
        if (!options.initial) galerie.afficher(0); // l'image principale passe à la couleur choisie
        if (options.source === "achat") {
          var api = apiHero();
          if (api) api.choisirColoris(id); // le hero met aussi à jour ?variant=
          else if (window.Layal && c.variante) window.Layal.majUrlVariante(c.variante);
        }
      } else {
        majBouton();
      }
    }

    // ---------- m. Ajout au panier : Solo par variante, Duo/Trio par produit lot tarifé ----------
    var formulaire = $("[data-lp-formulaire]", racine);
    var minuterieAjout = null;
    function ajouter(e) {
      if (e) e.preventDefault();
      if (!boutonAjouter || boutonAjouter.disabled || boutonAjouter.getAttribute("aria-busy") === "true") return;
      var lot = lotCourant();
      var q = Math.min(lot.quantite || 1, RANGS_SECTION);
      var couleurs = [], noms = [], lignes;
      for (var k = 0; k < q; k++) {
        var c = estAutre(lot, k) ? colorisAutreParId[couleurAutre(k)] : colorisParId[etat.couleurs[k]];
        if (!c || !c.variante) return;
        couleurs.push(c);
        noms.push(c.nom);
      }
      var choixComplement = complementChoisi();
      var v = varianteDe(etat.couleurs[0]);
      if (erreur) { erreur.hidden = true; erreur.textContent = ""; }
      try {
        lignes = window.Layal.lignesPourLot(lot, couleurs);
        if (choixComplement) lignes = lignes.concat([{ id: choixComplement.variante, quantity: 1 }]);
      } catch (err) {
        if (erreur) { erreur.hidden = false; erreur.textContent = err.message; }
        if (statutPanier) statutPanier.textContent = err.message;
        return { ok: false, message: err.message };
      }
      boutonAjouter.setAttribute("aria-busy", "true");
      return window.Layal.ajouterAuPanier(lignes, boutonAjouter).then(function () {
        boutonAjouter.classList.add("est-ajoute");
        if (statutPanier) statutPanier.textContent = "Ajouté au panier : " + lot.nom + ", " + listeFr(noms) + (v ? ", " + prix(calculLot(lot, v).paye) : "") + (choixComplement ? ", et le complément " + choixComplement.nom + ", " + prix(choixComplement.prix) : "") + ".";
        if (barreBouton) {
          barreBouton.classList.add("est-ajoute");
          setTimeout(function () { barreBouton.classList.remove("est-ajoute"); }, 1800);
        }
        clearTimeout(minuterieAjout);
        minuterieAjout = setTimeout(function () { boutonAjouter.classList.remove("est-ajoute"); }, 1800);
        return { ok: true };
      }, function (err) {
        var message = (err && err.message) || "Le panier n'a pas pu être mis à jour.";
        if (erreur) { erreur.textContent = message; erreur.hidden = false; }
        if (statutPanier) statutPanier.textContent = message;
        return { ok: false, message: message };
      }).then(function (r) { boutonAjouter.removeAttribute("aria-busy"); return r; });
    }
    if (formulaire) formulaire.addEventListener("submit", ajouter);
    // Bouton du hero réglé sur une formule (ex. voile aimanté) : même ajout que le bouton principal, résultat
    // { ok, message } ; { ok: false } sans message = rien n'a été envoyé (offre ou coloris indisponible).
    racine.lpAjouter = function () {
      return Promise.resolve(ajouter()).then(function (r) { return r || { ok: false }; });
    };

    // ---------- Complément : case jamais cochée d'avance, coloris montré une fois la case cochée ----------
    var zoneComplementColoris = $("[data-lp-complement-coloris]", racine);
    function majComplement() {
      var c = complementParId[etat.complement.id];
      if (!c) return;
      $$("[data-lp-complement-nom]", racine).forEach(function (el) { el.textContent = c.nom; });
      var img = $("[data-lp-complement-img]", racine);
      if (img && c.image && img.getAttribute("src") !== c.image) img.src = c.image;
      var prixEl = $("[data-lp-complement-prix]", racine);
      if (prixEl) prixEl.textContent = prix(c.prix);
      var refEl = $("[data-lp-complement-reference]", racine);
      if (refEl) {
        refEl.hidden = !(c.reference > c.prix);
        if (c.reference > c.prix) refEl.lastChild.textContent = prix(c.reference);
      }
    }
    if (complement && caseComplement) {
      caseComplement.checked = false; // jamais cochée d'avance, y compris après un retour arrière du navigateur
      caseComplement.addEventListener("change", function () {
        etat.complement.coche = caseComplement.checked;
        if (zoneComplementColoris) zoneComplementColoris.hidden = !caseComplement.checked;
        majBouton();
        var v = varianteDe(etat.couleurs[0]);
        if (statutPrix && v) statutPrix.textContent = "Total : " + prix(totalChoisi(v)) + ".";
      });
      $$("[data-lp-complement-choix]", racine).forEach(function (input) {
        input.addEventListener("change", function () {
          if (!input.checked) return;
          etat.complement.id = input.value;
          majComplement();
          majBouton();
        });
      });
    }

    // ---------- Barre d'achat collante (téléphone) ----------
    var barre = cfg.barre ? $("[data-lp-barre]", racine) : null;
    var barreNom = barre && $("[data-lp-barre-nom]", barre);
    var barrePrix = barre && $("[data-lp-barre-prix]", barre);
    var barreBouton = barre && $("[data-lp-barre-bouton]", barre);
    function majBarre(dispo, v) {
      if (!barre) return;
      var lot = lotCourant();
      if (barreNom) barreNom.textContent = lot.nom || "";
      if (barrePrix) barrePrix.textContent = dispo && v ? prix(totalChoisi(v)) : (textes.epuise || "");
      if (barreBouton) barreBouton.disabled = !dispo;
    }
    if (barre && barreBouton) {
      barreBouton.addEventListener("click", function () { ajouter(); });
      if ("IntersectionObserver" in window) {
        // Masquée tant qu'un élément d'achat est à l'écran : haut de page ([data-lp-cache-barre]), offres, couleurs,
        // bouton principal. Un seul bouton d'achat visible à la fois.
        var cibles = $$("[data-lp-lots], [data-lp-couleurs], [data-lp-actions]", racine).concat($$("[data-lp-cache-barre], [data-hero-couleurs] .hc__actions"));
        var visibles = new Set();
        var observateurBarre = new IntersectionObserver(function (entrees) {
          entrees.forEach(function (en) { if (en.isIntersecting) visibles.add(en.target); else visibles.delete(en.target); });
          barre.hidden = visibles.size > 0;
          document.documentElement.classList.toggle("lp-barre-visible", !barre.hidden);
        });
        cibles.forEach(function (el) { observateurBarre.observe(el); });
        var arreterAvant = racine._lpArreter;
        racine._lpArreter = function () {
          if (arreterAvant) arreterAvant();
          observateurBarre.disconnect();
          document.documentElement.classList.remove("lp-barre-visible");
        };
      }
    }

    // ---------- État initial, puis couleur du hero (?couleur= ou ?variant= compris) ----------
    // Offre cochée par le serveur (réglage « Offre présélectionnée », Duo par défaut) ; ses articles 2 et 3 suivent
    // la couleur de l'article 1 tant que la visiteuse ne les change pas (même règle que pour un Trio choisi).
    choisirLot(etat.lot, false);
    choisirCouleur(0, etat.couleurs[0], { initial: true });
    // majPrix vient d'activer les lots prêts : une offre présélectionnée restée inactive cède la place à Solo.
    var repli = lotDeRepli(lots, $$("[data-lp-lot]", racine));
    if (repli) {
      $$("[data-lp-lot]", racine).forEach(function (input) { input.checked = input.value === repli; });
      choisirLot(repli, false);
    }
    // ?offre= (liens des offres du guide) : cette offre à la place de la présélection, si elle existe et reste active.
    var demandee = lotDeAdresse(lots, $$("[data-lp-lot]", racine), window.location.search);
    if (demandee) {
      $$("[data-lp-lot]", racine).forEach(function (input) { input.checked = input.value === demandee; });
      choisirLot(demandee, false);
    }

    function brancherHero() {
      var api = apiHero();
      if (!api) return false;
      colorisDuHero();
      choisirCouleur(0, api.coloris(), { initial: true });
      return true;
    }
    var h = hero();
    if (h) {
      // Seuls les choix de la visiteuse dans le hero émettent « hc:coloris » (jamais le défilement automatique).
      h.addEventListener("hc:coloris", function (e) {
        if (e.detail && e.detail.id && racine.isConnected) choisirCouleur(0, e.detail.id, { source: "hero" });
      });
      if (!brancherHero()) h.addEventListener("hc:pret", brancherHero);
    } else {
      // Sans hero : ?variant= choisit la couleur de départ.
      try {
        var idVariante = new URLSearchParams(window.location.search).get("variant");
        coloris.forEach(function (c) { if (idVariante && String(c.variante) === idVariante) choisirCouleur(0, c.id, { initial: true }); });
      } catch (e) { /* adresse illisible */ }
    }
  }

  // ---------- Onglets : role tablist / tab / tabpanel, flèches du clavier, Début / Fin ----------
  function initOnglets(section) {
    if (section.dataset.lpPret) return;
    section.dataset.lpPret = "1";
    var rangee = $("[data-lp-onglets-liste]", section);
    var boutons = $$("[data-lp-onglet]", section);
    var zones = $$("[data-lp-panneau]", section);
    if (!rangee || !boutons.length) return;
    function activer(i, focus) {
      boutons.forEach(function (b, k) {
        var actif = k === i;
        b.setAttribute("aria-selected", actif ? "true" : "false");
        b.tabIndex = actif ? 0 : -1;
        if (zones[k]) zones[k].hidden = !actif;
      });
      if (focus) boutons[i].focus();
    }
    boutons.forEach(function (b, i) { b.addEventListener("click", function () { activer(i, false); }); });
    rangee.addEventListener("keydown", function (e) {
      var i = boutons.indexOf(document.activeElement);
      if (i < 0) return;
      var n = boutons.length, cible = null;
      if (e.key === "ArrowRight") cible = (i + 1) % n;
      else if (e.key === "ArrowLeft") cible = (i - 1 + n) % n;
      else if (e.key === "Home") cible = 0;
      else if (e.key === "End") cible = n - 1;
      if (cible === null) return;
      e.preventDefault();
      activer(cible, true);
    });
    // Éditeur : l'onglet sélectionné s'affiche.
    section.addEventListener("shopify:block:select", function (e) {
      var i = boutons.indexOf(e.target);
      if (i >= 0) activer(i, false);
    });
  }

  // ---------- Conseils du blog : défilement natif (scroll-snap) et flèches ----------
  // Cartes et liens rendus par sections/layal-conseils.liquid ; ici, seulement les flèches précédent / suivant.
  function initConseils(section) {
    if (section.dataset.lpPret) return;
    section.dataset.lpPret = "1";
    var piste = $("[data-lp-conseils-piste]", section);
    var fleches = $("[data-lp-conseils-fleches]", section);
    var prec = $('[data-lp-conseils-pas="-1"]', section);
    var suiv = $('[data-lp-conseils-pas="1"]', section);
    if (!piste || !piste.children.length || !fleches || !prec || !suiv) return;

    // Un clic avance d'autant de cartes qu'il en tient entièrement dans la rangée (au moins une).
    function defiler(sens) {
      var cartes = piste.children;
      var largeur = cartes[0].getBoundingClientRect().width;
      var pas = cartes.length > 1 ? cartes[1].offsetLeft - cartes[0].offsetLeft : largeur;
      var style = window.getComputedStyle(piste);
      var interieur = piste.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      var visibles = Math.max(1, Math.floor((interieur + pas - largeur) / pas + 0.01));
      piste.scrollBy({ left: sens * visibles * pas, behavior: animationsReduites() ? "auto" : "smooth" });
    }
    // Flèches : aria-disabled aux extrémités (le focus reste sur le bouton), masquées si rien ne dépasse.
    function majFleches() {
      var max = piste.scrollWidth - piste.clientWidth;
      fleches.hidden = max <= 1;
      prec.setAttribute("aria-disabled", piste.scrollLeft <= 1 ? "true" : "false");
      suiv.setAttribute("aria-disabled", piste.scrollLeft >= max - 1 ? "true" : "false");
    }
    [prec, suiv].forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.getAttribute("aria-disabled") === "true") return;
        defiler(parseInt(b.getAttribute("data-lp-conseils-pas"), 10));
      });
    });
    var trame = 0; // une mise à jour par image au plus pendant le défilement
    piste.addEventListener("scroll", function () {
      if (trame) return;
      trame = window.requestAnimationFrame(function () { trame = 0; majFleches(); });
    }, { passive: true });
    window.addEventListener("resize", majFleches);
    section._lpArreter = function () { window.removeEventListener("resize", majFleches); };
    majFleches();
  }

  // ---------- Tuiles vidéo : lecture sur place (délégation : toutes les sections, y compris rechargées) ----------
  document.addEventListener("click", function (e) {
    var bouton = e.target.closest && e.target.closest("button.lp-video__lecture[data-lp-video-src]");
    if (!bouton) return;
    var fig = bouton.closest(".lp-video");
    var img = fig && $("img", fig);
    $$(".lp-video video").forEach(function (v) { v.pause(); });
    var video = document.createElement("video");
    video.muted = bouton.getAttribute("data-lp-video-sans-son") === "true";
    video.defaultMuted = video.muted;
    video.src = bouton.getAttribute("data-lp-video-src");
    var affiche = bouton.getAttribute("data-lp-video-affiche");
    if (affiche) video.poster = affiche;
    video.controls = true;
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.autoplay = true;
    fig.classList.add("est-lue");
    if (img) fig.replaceChild(video, img);
    else fig.insertBefore(video, fig.firstChild);
    video.focus();
  });

  // ---------- WhatsApp flottant ----------
  // Le bouton flottant s'efface quand un contrôle important du bloc d'achat passe dessous (bas de l'écran) :
  // carrousel d'avis, lots, couleurs, bouton « Ajouter au panier ». Il revient dès qu'ils sont remontés.
  var observateur = null;
  function surveillerWhatsapp() {
    var flottant = $("[data-lp-flottant]");
    if (observateur) observateur.disconnect();
    if (!flottant || !("IntersectionObserver" in window)) return;
    var controles = $$("[data-lp-avis], [data-lp-lots], [data-lp-couleurs], [data-lp-actions]");
    if (!controles.length) return;
    var dessous = new Set();
    var bande = Math.max(0, window.innerHeight - 110); // bande basse de l'écran où se trouve le bouton flottant
    observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) { if (en.isIntersecting) dessous.add(en.target); else dessous.delete(en.target); });
      var f = flottant.getBoundingClientRect();
      var masque = false;
      dessous.forEach(function (el) { if (el.getBoundingClientRect().right > f.left - 8) masque = true; });
      flottant.classList.toggle("est-discret", masque);
    }, { rootMargin: "-" + bande + "px 0px 0px 0px" });
    controles.forEach(function (el) { observateur.observe(el); });
  }
  var attente = null;
  window.addEventListener("resize", function () { clearTimeout(attente); attente = setTimeout(surveillerWhatsapp, 200); });

  // ---------- Ancres : ouvrir la question de FAQ visée, fermer le menu du hero ----------
  function ouvrirQuestion(id) {
    var el = null;
    try { el = id && document.getElementById(id); } catch (e) { el = null; }
    if (el && el.tagName === "DETAILS") el.open = true;
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var quantite = Number(a.getAttribute("data-lp-choisir-quantite"));
    if (quantite >= 1 && quantite <= RANGS && quantite % 1 === 0) {
      var produit = $("[data-lp-produit]");
      if (produit && produit.lpChoisirQuantite) produit.lpChoisirQuantite(quantite);
    }
    ouvrirQuestion(decodeURIComponent(a.getAttribute("href").slice(1)));
    var menu = $("[data-hc-menu]");
    var boutonMenu = $("[data-hc-menu-bouton]");
    if (menu && boutonMenu && menu.contains(a)) {
      menu.hidden = true;
      boutonMenu.setAttribute("aria-expanded", "false");
    }
  });
  window.addEventListener("hashchange", function () { ouvrirQuestion(decodeURIComponent(location.hash.slice(1))); });

  // Éditeur : une question sélectionnée s'ouvre.
  document.addEventListener("shopify:block:select", function (e) {
    if (e.target && e.target.tagName === "DETAILS" && e.target.classList.contains("lp-question")) e.target.open = true;
  });

  // ---------- Démarrage et éditeur de thème ----------
  // Ouverture de la page avec une ancre (ex. #choisir-mon-lot depuis les offres du guide) : le navigateur y défile
  // de lui-même, mais html { scroll-behavior: smooth } (layal-produit.css) le fait glisser depuis le haut (relevé :
  // 0,2 s après le chargement dans Safari, 0,7 s dans Chrome). On se place tout de suite sur la cible, sans
  // animation ; le défilement doux revient après le chargement (liens internes de la page inchangés).
  // Le navigateur donne aussi le focus à la cible (titre en tabindex="-1") et l'entoure d'un anneau : pas d'anneau
  // sur ce titre non interactif à l'arrivée ; il revient dès que le focus le quitte.
  function arriverSurAncre() {
    var id = "";
    try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
    var cible = id ? document.getElementById(id) : null;
    if (!cible || typeof cible.scrollIntoView !== "function") return;
    var html = document.documentElement;
    html.style.scrollBehavior = "auto";
    cible.scrollIntoView({ block: "start" });
    if (cible.getAttribute("tabindex") === "-1") {
      cible.style.outline = "none";
      cible.addEventListener("blur", function () { cible.style.outline = ""; }, { once: true });
    }
    function retablir() { setTimeout(function () { html.style.scrollBehavior = ""; }, 300); }
    if (document.readyState === "complete") retablir();
    else window.addEventListener("load", retablir);
  }

  function demarrer() {
    $$("[data-lp-produit]").forEach(initProduit);
    $$("[data-lp-onglets]").forEach(initOnglets);
    $$("[data-lp-conseils]").forEach(initConseils);
    surveillerWhatsapp();
    ouvrirQuestion(decodeURIComponent(location.hash.slice(1)));
    arriverSurAncre();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
  document.addEventListener("shopify:section:load", function () {
    $$("[data-lp-produit]").forEach(initProduit);
    $$("[data-lp-onglets]").forEach(initOnglets);
    $$("[data-lp-conseils]").forEach(initConseils);
    surveillerWhatsapp();
  });
  document.addEventListener("shopify:section:unload", function (e) {
    $$("[data-lp-produit], [data-lp-conseils]", e.target).forEach(function (r) { if (r._lpArreter) r._lpArreter(); });
  });
})();
